import { taskIdSchema } from "@repo/api/schemas";
import { type ManualTaskDto, useTasks } from "@repo/data-store";
import { buttonVariants } from "@repo/ui/components/ui/button";
import { createFileRoute, Link } from "@tanstack/react-router";
import { RegistrationReview } from "@/features/patients";

export const Route = createFileRoute("/tasks/$taskId_/review")({
  component: RegistrationReviewComponent,
});

function RegistrationReviewComponent() {
  const { taskId: taskIdParam } = Route.useParams();
  const taskId = taskIdSchema.parse(taskIdParam);
  const { tasks, isLoading } = useTasks({ taskId });
  const task = tasks.find((candidate): candidate is ManualTaskDto => candidate.taskId !== undefined);
  if (!task) {
    if (isLoading) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>;
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4">
        <p className="text-muted-foreground">Review not found</p>
        <Link to="/tasks" className={buttonVariants({ variant: "outline", size: "sm" })}>
          Back to tasks
        </Link>
      </div>
    );
  }
  return <RegistrationReview task={task} />;
}
